module.exports = __webpack_public_path__ + "img/feature-03-zh.e8b45cde.png";